<script>
import {
  BaseAffiliateLinkElementMixin,
} from "%/dynamic-component-editor/standard-components/base-affiliate-link-card/base-affiliate-link-element-mixin";
import ActionCountElement
  from "%/dynamic-component-editor/standard-elements/action-element/ActionCountElement.vue";
import DisplayValue from "%/dynamic-component-editor/options/display-value";

export default {
  name: "ProductLinkClicks",
  elementPanelSettings: {
    displayName: "Click Count",
    displayIcon: "text-alt",
    elementType: "element",
    elementGroup: "Product",
  },
  extends: ActionCountElement,
  mixins: [BaseAffiliateLinkElementMixin],
  computed: {
    myValue() {
      return this.getOptionValue(DisplayValue) === "hide" ? "" : this.entity.clicks;
    },
    shouldShowAction() {
      return !!this.label;
    },
  },
  methods: {
    handleClick() {
      window.location.href = this.entity.affiliateLink;
    },
  },
};
</script>
